import { Component, Input, OnInit } from '@angular/core';
import { Badge } from '@awesome-cordova-plugins/badge/ngx';
import { Platform } from '@ionic/angular';
import { TaskService } from 'app/services/task.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-reminder-badge',
    templateUrl: './reminder-badge.component.html',
    styleUrls: ['./reminder-badge.component.scss'],
    standalone: false
})
export class ReminderBadgeComponent implements OnInit
{

    constructor
        (
            private taskService: TaskService,
            private platform: Platform,
            private badge: Badge
        ) { }

    @Input() showNumbers: boolean = false;
    @Input() redBadge: boolean = true;
    loading: boolean = false;
    reminders: number;
    remindersRounded: string;
    public subscription: Subscription;
    ngOnInit()
    {

        this.loading = true;

        this.taskService.remindersSubject.subscribe(
            (message) =>
            {
                if (!message) 
                {
                    this.taskService.getReminders()
                        .subscribe({
                            next: x => {
                                this.setReminderCount(x.resultCount);
                            },
                            error: error => {
                                console.log(error);
                            }
                        });
                }
                else
                {
                    this.setReminderCount(message.resultCount);
                }
            }
        );
        // setTimeout(() =>
        // {
        //     this.taskService.getCachedCount().subscribe(
        //         countresult =>
        //         {
        //             this.notificationService.setLocalNotificationCount(countresult);
                    this.loading = false;
        //         }
        //     );
        // }, 2000);
    }

    ngOnDestroy()
    {
        if (this.subscription) { this.subscription.unsubscribe(); }
    }

    setReminderCount(count: number)
    {
        this.loading = true;
        this.reminders = count;
        this.remindersRounded = count + '';
        if (count > 99)
        {
            this.remindersRounded = "99+";
        }
        this.setNativeFlag();
        setTimeout(() =>
        {
            this.loading = false;
        }, 250);
    }

    setNativeFlag()
    {
        if (this.platform.is('cordova'))
        {
            // console.log("Setting app badge", this.notifications)
            this.badge.set(this.reminders);
        }
        else
        {
            // console.log("Not able to set app badge as is not native");
        }
    }
}